import { CommonModule } from '@angular/common';
import { Inject, NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { GridCellDblClickDirective } from '@app/shared/directives/grid-cell-dbl-click.directive';
import { KendoModule } from '@app/shared/kendo.module';
import { GridDataBindingDirective } from '@app/shared/directives/grid-data-binding.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropDownListFilterComponent } from '@app/shared/components/drop-down-list-filter/drop-down-list-filter.component';
import { BreadcrumbComponent } from '@app/shared/components/breadcrumb/breadcrumb.component';
import { RouterModule } from '@angular/router';
import {
  FileGroupClassPipe,
  FileSelectComponent,
  FileStatusClassPipe,
  FileStatusTextPipe,
} from '@app/shared/components/file-select';
import { FileViewerComponent, ResourceUrlPipe } from '@app/shared/components/file-viewer';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AcceptFilesPipe } from '@app/shared/components/file-select/accept-files.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatGridListModule } from '@angular/material/grid-list';
import { DateRelativePipe } from '@app/shared/pipes/date-relative.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EntityProvider, EntityProviderStoreServiceImpl } from '@technocom/data';
import { EntityProviderStoreExtensionService } from '@app/shared/services/entity-provider-store-extension.service';
import { TranslocoRootModule } from '@app/shared/transloco-root.module';
import { TkUiModule } from '@technocom/ui';
import { TkCommonModule } from '@technocom/common';
import { Localizable } from '@app/shared/models/localizable/localizable';
import { LocalizableProviderStoreService } from '@app/shared/models/localizable/localizable-provider-store.service';
import { CardsListComponent } from '@app/shared/components/card/card-list/cards-list.component';
import { PreviewCardComponent } from '@app/shared/components/card/preview-card/preview-card.component';
import { VideoViewerComponent } from '@app/shared/components/video-viewer/video-viewer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DropDownDataBindingDirective } from '@app/shared/directives/drop-down-data-binding.directive';
import { ActionFormButtonComponent } from '@app/shared/components/action-form-button/action-form-button.component';
import { DatePickerOptionsDirective } from '@app/shared/directives/date-picker-options.directive';
import { MetrikaCounterComponent } from '@app/shared/components/metrika-counter/metrika-counter.component';

const imports = [
  RouterModule,
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  KendoModule,
  DragDropModule,
  TkCommonModule,
  TkUiModule,
  // Материал ui
  MatButtonModule,
  MatCardModule,
  MatListModule,
  MatTabsModule,
  MatDialogModule,
  MatBadgeModule,
  MatRippleModule,
  MatFormFieldModule,
  MatInputModule,
  MatDatepickerModule,
  MatGridListModule,
  MatNativeDateModule,
  MatTooltipModule,
  TranslocoRootModule,
];

const declarations = [
  GridCellDblClickDirective,
  GridDataBindingDirective,
  DropDownListFilterComponent,
  BreadcrumbComponent,
  FileSelectComponent,
  FileViewerComponent,
  ResourceUrlPipe,
  FileStatusTextPipe,
  FileStatusClassPipe,
  FileGroupClassPipe,
  AcceptFilesPipe,
  DateRelativePipe,
  CardsListComponent,
  PreviewCardComponent,
  VideoViewerComponent,
  ActionFormButtonComponent,
  MetrikaCounterComponent,
  // directives
  DropDownDataBindingDirective,
  DatePickerOptionsDirective,
];

@NgModule({
  declarations: [...declarations],
  providers: [
    {
      provide: EntityProviderStoreServiceImpl,
      useExisting: EntityProviderStoreExtensionService,
    },
  ],
  imports: [...imports],
  exports: [...imports, ...declarations],
})
export class SharedModule {
  constructor(@Inject(EntityProvider) entityProvider: EntityProvider) {
    entityProvider.addProviderStore(Localizable, LocalizableProviderStoreService);
  }
}
